import { render, staticRenderFns } from "./user-followup-5.vue?vue&type=template&id=2066343a&scoped=true"
import script from "./user-followup-5.vue?vue&type=script&lang=js"
export * from "./user-followup-5.vue?vue&type=script&lang=js"
import style0 from "./user-followup-5.vue?vue&type=style&index=0&id=2066343a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066343a",
  null
  
)

export default component.exports